import {
  faHeart,
  faPills,
  faTablets,
  faTooth,
  faKitMedical,
  faDumbbell,
  faHandDots,
  faPersonDress,
  faDollar,
} from '@fortawesome/free-solid-svg-icons';
import { Filter, FilterType } from './types';

export const SELECTED_COLOR = 'blue';
export const DEFAULT_COLOR = 'gray';

export const FILTERS: Filter[] = [
  {
    type: FilterType.TAG,
    name: 'Favorites',
    icon: faHeart,
  },
  {
    type: FilterType.PRICE,
    name: 'Remaining balance',
    icon: faDollar,
  },
  {
    type: FilterType.TAG,
    name: 'Allergy',
    icon: faTablets,
  },
  {
    type: FilterType.TAG,
    name: 'First Aid',
    icon: faKitMedical,
  },
  {
    type: FilterType.TAG,
    name: 'Fitness',
    icon: faDumbbell,
  },
  {
    type: FilterType.TAG,
    name: 'Personal Care',
    icon: faTooth,
  },
  {
    type: FilterType.TAG,
    name: 'Pain Reliever',
    icon: faPills,
  },
  {
    type: FilterType.TAG,
    name: 'Skin Care',
    icon: faHandDots,
  },
  {
    type: FilterType.TAG,
    name: 'Vitamins',
    icon: faPills,
  },
  {
    type: FilterType.TAG,
    name: 'Women’s Health',
    icon: faPersonDress,
  },
];
